import { Modal, TreeSelect, Typography } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useGetPermissionsQuery } from '../../../auth/store/auth.api';
import { axiosApi } from '../../../core';
import { useGetUserPermissionsQuery } from '../store/user.api';

const { Paragraph } = Typography;

type TProps = {
  open: boolean;
  userId: string;
  close: () => void;
};

export const PermissionsModal: React.FC<TProps> = ({ open, close, userId }) => {
  const [selected, setSelected] = useState<string[]>([]);

  const { data: permissions } = useGetPermissionsQuery();
  const { data: assignedPermissions, refetch } = useGetUserPermissionsQuery(
    {
      id: userId,
    },
    {
      skip: !open || !userId,
    },
  );

  useEffect(() => {
    if (open && userId) {
      refetch();
    }
  }, [open, userId, refetch]);

  useEffect(() => {
    if (assignedPermissions?.data) {
      setSelected(assignedPermissions.data.map((permission) => permission.id));
    }
  }, [assignedPermissions?.data]);

  const onOk = useCallback(async () => {
    try {
      await axiosApi.put('/auth/permissions', {
        data: { attributes: { permissions: selected, user_id: userId } },
      });

      close();
    } catch (err) {}
  }, [selected, userId, close]);

  return (
    <Modal
      open={open}
      title="Update Permissions"
      onCancel={close}
      okText="Update"
      onOk={onOk}
    >
      <Paragraph>
        Update the user permissions by selecting the desired permissions from
        the list below.
      </Paragraph>
      <TreeSelect
        placeholder="Please select"
        style={{ width: '100%' }}
        treeCheckable
        treeNodeFilterProp="title"
        multiple
        value={selected}
        onChange={(value) => setSelected(value)}
        treeData={permissions}
      />
    </Modal>
  );
};
